import { ActionIcon, Card, Grid, Text, Title } from '@mantine/core';
import { IconX } from '@tabler/icons-react';

const GeneratedLandingMarketingCard = ({ option, marketingChannel, selectMarketingChannel }) => {
  const isSelected = option.marketingChannel === marketingChannel;

  return (
    <Grid.Col span={{ base: 12, md: 4 }} mb="lg">
      <Card
        withBorder
        className={`subscription-card ${isSelected ? 'subscription-card-selected' : ''}`}
        onClick={() => selectMarketingChannel(option)}
        padding="md"
        style={{ cursor: 'pointer', height: '100%', position: 'relative' }}
      >
        {isSelected && (
          <ActionIcon
            variant="subtle"
            color="gray"
            size="sm"
            style={{ position: 'absolute', top: 8, right: 8 }}
            onClick={(e) => {
              e.stopPropagation();
              selectMarketingChannel(false);
            }}
          >
            <IconX size={16} />
          </ActionIcon>
        )}
        <Title order={2}>
          {option.tablerIcon || null} {option.title}
        </Title>
        <Text c="dimmed" mb={0}>
          {option.description}
        </Text>
      </Card>
    </Grid.Col>
  );
};

export default GeneratedLandingMarketingCard;
